<template>
  <div class="text-input">
    <ValidationProvider
      v-slot="{ errors }"
      :name="label"
      :rules="validationRules"
    >
      <label
        v-if="label || required"
        :for="`input-${name}`"
        class="vs-input--label mb-1"
        >{{ label }}
        <span v-if="required" class="text-danger"
          ><feather-icon icon="star-of-life"/></span
        ><a v-if="actionUrl" :href="actionUrl" class="text-primary"
          ><feather-icon icon="external-link"/></a
      ></label>
      <vs-input
        v-model="internalValue"
        :type="type"
        class="w-full data-input"
        :placeholder="placeholder"
        :name="name"
        :class="{ error: errors.length }"
        :disabled="disabled"
        :readonly="readonly"
      />
      <span v-show="errors.length" class="text-danger text-sm">{{
        errors[0]
      }}</span>
    </ValidationProvider>
  </div>
</template>

<script>
export default {
  props: {
    value: { type: [String, Number], default: null },
    validationRules: {
      type: [Object, String],
      default() {
        return null;
      }
    },
    label: { type: String, default: null },
    placeholder: { type: String, default: null },
    name: { type: String, required: true },
    type: { type: String, default: "text" },
    required: { type: Boolean, default: false },
    default: { default: false },
    disabled: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false }
  },
  computed: {
    internalValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    actionUrl() {
      if (this.type === "tel" && this.value && this.value.length > 3) {
        return `callto:${this.value}`;
      } else if (
        this.type === "email" &&
        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
          this.value
        )
      ) {
        return `mailto:${this.value}`;
      }

      return null;
    }
  },
  mounted() {
    if (this.default && !this.internalValue) {
      this.internalValue = this.default;
    }
  }
};
</script>
